module.exports = __webpack_public_path__ + "static/media/laughing_people_cropped.5f149aa5.jpg";